/**
 * Label + control row used by every field in the Binom Campaign tab.
 * Right-aligned label, control fills remaining width — mirrors the Binom
 * panel's two-column layout.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface BinomCampaignFormRowProps {
  label: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}

const BinomCampaignFormRow: FC<BinomCampaignFormRowProps> = ({
  label,
  hint,
  children,
  className,
}) => (
  <div
    className={cn(
      'grid grid-cols-[8rem_minmax(0,1fr)] items-center gap-2',
      className,
    )}
  >
    <label
      className="text-right text-xs font-medium text-muted-foreground"
      title={hint}
    >
      {label}
    </label>
    <div className="min-w-0">{children}</div>
  </div>
);

export default BinomCampaignFormRow;
